import React, { useState, useEffect } from "react";

export const useArduino = () => {
  const [selectedPort, setSelectedPort] = useState(null);
  const baudRate = 115200;
  const [output, setOutput] = useState("");
  const [reader, setReader] = useState(null);
  const [writer, setWriter] = useState(null);
  const [connected, setConnected] = useState(false);
  const [portInfo, setPortInfo] = useState(null);

  useEffect(() => {
    return () => {
      (async () => {
        try {
          if (reader) {
            await reader.cancel();
            reader.releaseLock();
          }
          if (writer) {
            await writer.close();
          }
          if (selectedPort) {
            await selectedPort.close();
          }
          setOutput("");
        } catch (err) {
          console.warn("Eroare la cleanup în useEffect:", err);
        }
      })();
    };
  }, [reader, writer, selectedPort]);

  const requestSerialPort = async () => {
    try {
      const port = await navigator.serial.requestPort();
      const info = port.getInfo();
      console.log("Port selected:", info, port);
      setSelectedPort(port);
      setPortInfo(info);

      await connect(port); // conectează
    } catch (err) {
      console.error("User did not select a port:", err);
    }
  };

  const connect = async (portToUse = selectedPort) => {
    if (!portToUse) return alert("No port selected");

    if (connected) {
      console.log("Already connected.");
      return;
    }
    try {
      await portToUse.open({ baudRate });
      // Reader setup
      const decoder = new TextDecoderStream();

      const readableStreamClosed = portToUse.readable.pipeTo(decoder.writable);
      readableStreamClosed.catch((error) => {
        console.error("Pipe error:", error);
      });

      const textReader = decoder.readable.getReader();
      setReader(textReader);

      // Writer setup
      const encoder = new TextEncoderStream();
      const writableStreamClosed = encoder.readable.pipeTo(portToUse.writable);
      writableStreamClosed.catch((error) => {
        console.error("Writer pipe error:", error);
      });

      const textWriter = encoder.writable.getWriter();
      setWriter(textWriter);

      setConnected(true);

      const readLoop = async () => {
        try {
          while (true) {
            const { value, done } = await textReader.read();
            if (done) break;
            if (value) setOutput(value);
          }
        } catch (err) {
          if (err.name === "NetworkError" || err.name === "AbortError") {
            console.log("Citirea a fost întreruptă în mod controlat.");
          } else {
            console.error("Eroare în citirea serială:", err);
          }
        }
      };

      readLoop().catch(console.error);
    } catch (err) {
      alert("Portul este deja deschis!");
      console.error("Connection failed:", err);
    }
  };

  const disconnectArduino = async () => {
    console.log("Disconnecting...");
    if (reader) {
      try {
        await reader.cancel();
        reader.releaseLock();
        console.log("Reader canceled and lock released.");
      } catch (err) {
        console.warn("reader cancel/releaseLock failed:", err);
      }
      setReader(null);
    }
    if (writer) {
      try {
        await writer.close();
        console.log("Writer closed.");
      } catch (err) {
        console.warn("writer.close() failed:", err);
      }
      setWriter(null);
    }
    if (selectedPort) {
      try {
        await selectedPort.close();
      } catch (err) {
        console.warn("selectedPort.close() failed:", err);
      }
      setSelectedPort(null);
      setPortInfo(null);
    }
    setConnected(false);
  };

  const sendCommand = async (command) => {
    if (!writer) {
      console.warn("Writer nu este inițializat");
      return;
    }
    try {
      await writer.write(command + "\n");
      console.log("Trimis comanda:", command);
    } catch (err) {
      console.error("Eroare la trimiterea comenzii:", err);
    }
  };

  return {
    requestSerialPort,
    connect,
    disconnectArduino,
    sendCommand,
    output,
    connected,
    portInfo,
  };
};
